/**
 * Main product — vertical thumbnail strip: scroll up/down buttons
 */
(function () {
  function getVerticalThumbnailScrollStep(scroller) {
    var thumbs = scroller.querySelectorAll('.product-gallery__thumbnail:not([hidden])');
    if (thumbs.length >= 2) {
      return Math.max(1, Math.round(thumbs[1].offsetTop - thumbs[0].offsetTop));
    }
    if (thumbs.length === 1) {
      return Math.max(1, Math.round(thumbs[0].getBoundingClientRect().height));
    }
    return 72;
  }

  function bindThumbnailScrollNav(root) {
    root.querySelectorAll('[data-thumbnail-scroll-nav]').forEach(function (nav) {
      if (nav.dataset.thumbScrollBound === 'true') return;
      nav.dataset.thumbScrollBound = 'true';

      var gallery = nav.closest('product-gallery');
      if (!gallery) return;

      var scroller = gallery.querySelector('product-gallery-navigation.product-gallery__thumbnail-scroller');
      if (!scroller) return;

      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb-scroll]');
        if (!btn || !nav.contains(btn)) return;

        var dir = btn.getAttribute('data-thumb-scroll');
        var step = getVerticalThumbnailScrollStep(scroller);
        if (dir === 'up') {
          scroller.scrollBy({ top: -step, behavior: 'smooth' });
        } else if (dir === 'down') {
          scroller.scrollBy({ top: step, behavior: 'smooth' });
        }
      });
    });
  }

  function init(scope) {
    bindThumbnailScrollNav(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && typeof e.target.querySelector === 'function') {
      init(e.target);
    }
  });
})();

(function () {
  var root = document.querySelector('.shopify-section--main-product [data-main-product-id]');
  if (!root) return;
  var id = root.getAttribute('data-main-product-id');
  if (!id) return;
  window.ShopifySections?.trackRecentlyViewedProduct?.(Number(id));
})();

/**
 * PDP: Wishlist Hero app embed — mount next to Add to cart only (no theme wishlist markup).
 * Slot lives outside buy-buttons so variant AJAX rerender does not destroy the app button.
 */
(function () {
  var BLOCK_SELECTOR = '.shopify-section--main-product [data-block-type="buy-buttons"], .shopify-section--featured-product [data-block-type="buy-buttons"]';
  var SECTION_SELECTOR = '.shopify-section--main-product, .shopify-section--featured-product';
  var SLOT_SELECTOR = '.buy-buttons__wishlist-slot';
  var WLH_BUTTON_SELECTOR = '.wishlist-hero-custom-button, [data-wlh-view="Product"]';
  var placementTimers = [];

  function inSlot(el, slot) {
    return el && slot && slot.contains(el);
  }

  function getBuyButtonsBlock(root) {
    var scope = root || document;
    if (scope.matches && scope.matches(BLOCK_SELECTOR)) return scope;
    return scope.querySelector(BLOCK_SELECTOR);
  }

  function showWishlistButton(btn) {
    if (!btn) return;
    btn.removeAttribute('hidden');
    btn.removeAttribute('aria-hidden');
    btn.style.removeProperty('display');
  }

  function hideWishlistButton(btn) {
    if (!btn) return;
    btn.setAttribute('hidden', '');
    btn.style.setProperty('display', 'none', 'important');
    btn.setAttribute('aria-hidden', 'true');
  }

  function findWishlistButtons(root) {
    var section = (root || document).querySelector(SECTION_SELECTOR) || document;
    return Array.prototype.slice.call(section.querySelectorAll(WLH_BUTTON_SELECTOR));
  }

  function placePdpWishlistFromApp(root) {
    var block = getBuyButtonsBlock(root || document);
    if (!block) return;

    var slot = block.querySelector(SLOT_SELECTOR);
    if (!slot) return;

    var moved = false;

    findWishlistButtons(document).forEach(function (btn) {
      if (inSlot(btn, slot)) {
        showWishlistButton(btn);
        return;
      }

      if (!moved && !slot.querySelector(WLH_BUTTON_SELECTOR)) {
        slot.appendChild(btn);
        showWishlistButton(btn);
        moved = true;
        return;
      }

      if (!inSlot(btn, slot)) {
        hideWishlistButton(btn);
      }
    });
  }

  function scheduleWishlistPlacement() {
    placementTimers.forEach(clearTimeout);
    placementTimers = [];

    window.requestAnimationFrame(function () {
      placePdpWishlistFromApp(document);
    });

    [50, 150, 400, 800, 1500, 2500].forEach(function (delay) {
      placementTimers.push(window.setTimeout(function () {
        placePdpWishlistFromApp(document);
      }, delay));
    });
  }

  function initPdpWishlistPlacement(scope) {
    scheduleWishlistPlacement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPdpWishlistPlacement(document);
    });
  } else {
    initPdpWishlistPlacement(document);
  }

  document.addEventListener('variant:change', scheduleWishlistPlacement);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && typeof e.target.querySelector === 'function') {
      initPdpWishlistPlacement(e.target);
    }
  });
})();
